import $ from 'jquery';
import splide from '@splidejs/splide';

window.splide = splide;
window.jQuery = window.$ = $;

import './app.js';
